<div class="page-header">
    <h1 class="page-title">{{ "adaa4.welcome_title" | translate }}</h1>
    <p class="page-eyebrow">{{ "adaa4.select_dashboard" | translate }}</p>
</div>

<div class="gauges">
    @for (card of cards(); track card.id) {
        <a class="gauge-card" [href]="card.url" (click)="open($event, card.url)">
            <h2 class="gauge-title">{{ card.title | translate }}</h2>

            <adaa-adaa4-gauge class="w-100 d-flex justify-content-center" [value]="card.value" />

            @if (card.trend !== null) {
                <div class="trend" [class.trend--down]="card.trend < 0">
                    <span class="trend-label">{{ "adaa4.compared_to_last_period" | translate }}</span>
                    <span class="trend-value">{{ trend(card.trend) }}</span>
                </div>
            }

            <ul class="legend">
                <li><span class="swatch swatch--green"></span>{{ card.actualLabel | translate }}</li>
            </ul>

            <span class="cta">
                <span>{{ "adaa4.open_dashboard" | translate }}</span>
                <span class="cta-arrow" aria-hidden="true">→</span>
            </span>
        </a>
    }
</div>
